export default __webpack_public_path__ + "static/media/portrait1.1a07b569.png";